// extracted by mini-css-extract-plugin
module.exports = {"root":"Alert_root__2Lf_v"};